/* 渲染顶部车的类型 */
import React, { useState, useEffect } from 'react'
import classnames from 'classnames'
import { sendTeaCommEvent } from 'lib/tea-analyze'
import Link from 'next/link'
import {
  useResponsive,
  computedResponsive,
} from 'Components/hooks/use-responsive'

import { DEFAULT_TYPE } from './popular-model'

interface ICarData {
  value?: number | string
  link?: string
  text: string
  imgIndex: number
  className?: string
}

export default function TypeList() {
  const carList = [
    {
      link: '/auto/library/x-x-x-x-x-x-4-x-x-x-x',
      value: 'ev',
      text: '新能源',
      className: 'xl:tw-mr-74 2xl:tw-mr-86',
      imgIndex: 4,
    },
    {
      value: 0,
      text: '轿车',
      imgIndex: 0,
    },
    {
      value: 1,
      text: 'SUV',
      imgIndex: 1,
    },
    {
      value: 2,
      text: 'MPV',
      imgIndex: 2,
    },
    {
      value: 4,
      text: '跑车',
      imgIndex: 3,
    },
    {
      value: 3,
      text: '皮卡',
      imgIndex: 5,
    },
    {
      value: 7,
      text: '微面',
      imgIndex: 6,
    },
    {
      value: 8,
      text: '微卡',
      imgIndex: 7,
    },
    {
      value: 6,
      text: '轻客',
      imgIndex: 8,
    },
  ]

  const responsive = useResponsive()

  const [type, setType] = useState(DEFAULT_TYPE)

  useEffect(() => {
    setType(computedResponsive(responsive))
  }, [responsive])

  const getIconLeft = (index: number) => {
    if (index === 1) {
      return index * -134 - 12
    }
    return index === 0 ? -16 : index * -134 - 16
  }

  /* 渲染车型的分类 */
  function renderCar(param: ICarData, index: number) {
    const link = param.link
      ? param.link
      : `/auto/library/x-${param.value}-x-x-x-x-x-x-x-x-x`
    return (
      <Link href={link} key={param.value} as={link}>
        <a
          target="_blank"
          className={`whole tw-mr-0 md:tw-mr-14 lg:tw-mr-28 ${
            param.className || 'xl:tw-mr-45 2xl:tw-mr-72'
          } ${type}`}
          onClick={() => {
            sendTeaCommEvent('clk_event', {
              event_id: 'select_module_series_pic_and_text',
              car_series_name: param.text,
              car_series_id: `${param.value}`,
              module_id: 'select_module',
            })
          }}
        >
          <div>
            <div className="icon-wrap">
              <span
                className={`
                icon
                icon-${param.imgIndex}
                tw-transform
                tw-scale-65
                xl:tw-scale-96
                md:tw-scale-86
                sm:tw-scale-65
                `}
              />
              <span
                className={`
                  value
                  tw-text-14
                  md:tw-text-16
                  tw-mb-7
                  sm:tw-mb-7
                  xl:tw-mb-0
                  tw-text-center
                  xl:tw-text-left
                  tw-left-0
                  xl:tw-left-74
                  tw--bottom-25
                  xl:tw-bottom-4`}
              >
                {param.text}
              </span>
            </div>
          </div>
          <style jsx>
            {`
              .whole {
                flex: 1;
                height: 100%;
                text-align: left;
              }
              .icon:hover {
                background-position: ${getIconLeft(param.imgIndex)}px -64px;
              }
              .icon-wrap {
                position: relative;
                display: inline-block;
                width: 68px;
                height: 32px;
              }
              .icon {
                position: relative;
                display: inline-block;
                width: 68px;
                height: 32px;
                background-repeat: no-repeat;
                cursor: pointer;
                background-position: 0 0;
                background-image: url(${require('./static/cartype.png')});
                background-size: 1174px 112px;
                background-position: ${getIconLeft(param.imgIndex)}px -16px;
              }
              .value {
                color: #1f2129;
                position: absolute;
                width: 100%;
              }
            `}
          </style>
        </a>
      </Link>
    )
  }

  return (
    <div
      className={classnames(
        'choose-car type-list tw-mb-16 xl:tw-mb-0 lg:tw-pr-60',
        type
      )}
    >
      {carList.map((item: ICarData, index: number) => renderCar(item, index))}
      <style jsx>
        {`
          .type-list {
            margin-top: 24px;
            height: 56px;
            width: 100%;
            display: flex;
            justify-content: space-between;
          }
        `}
      </style>
    </div>
  )
}
